import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { MiniTabBar } from 'components';
import { FBDesktopPreview, FBRightPreview, FBMobilePreview, InstagramPreview } from '../Previews';
import * as styles from './AdTypePicker.scss';
var AdTypePicker = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    type: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].type : '',
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdTypePicker, _Component);

  var _super = _createSuper(AdTypePicker);

  function AdTypePicker(props) {
    var _this;

    _classCallCheck(this, AdTypePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handlePreviewTabChange", function (selectedPreviewTab) {
      var tabCopy = [].concat(_this.state.adPreviewTabs);
      tabCopy.forEach(function (tab) {
        tab.selected = tab.key === selectedPreviewTab.key;
      });

      _this.setState({
        adPreviewTabs: tabCopy,
        selectedPreviewTab: selectedPreviewTab
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTypeDetails", function (type) {
      var name, summary, designDetails;

      if (type === 'brandAwareness') {
        name = 'Brand Awareness';
        summary = 'The first step to a successful business is to build brand awareness. Reach people who are more likely to pay attention to your ads with the brand awareness objective.';
        designDetails = {
          imageSize: '1200x628 pixels',
          imageRatio: '1.9:1',
          text: '90 Characters',
          headline: '25 Characters',
          linkDescription: '30 Characters'
        };
      } else if (type === 'clicksToWebsite') {
        name = 'Clicks To Website';
        summary = 'Send people to important sections of your website.';
        designDetails = {
          imageSize: '1200x628 pixels',
          imageRatio: '1.9:1',
          text: '90 Characters',
          headline: '25 Characters',
          linkDescription: '30 Characters'
        };
      } else if (type === 'leadGeneration') {
        name = 'Lead Generation';
        summary = 'Add a form to your ad to collect info from people interested in your business.';
        designDetails = {
          imageSize: '1200x628 pixels',
          imageRatio: '1.9:1',
          text: '90 Characters',
          headline: '25 Characters',
          newsFeedDescription: '30 Characters'
        };
      } else if (type === 'localAwareness') {
        name = 'Local Awareness';
        summary = 'Create ads that reach people near your business.';
        designDetails = {
          imageSize: '1200x628 pixels',
          imageRatio: '1.9:1',
          text: '90 Characters',
          headline: '25 Characters',
          newsFeedDescription: '30 Characters'
        };
      } else if (type === 'offerClaims') {
        name = 'Offer Claims';
        summary = 'Create limited-time discounts and promotions that people can claim in your store or on your website.';
        designDetails = {
          imageSize: '1200x628 pixels',
          imageRatio: '1.9:1',
          text: '90 Characters',
          headline: '25 Characters'
        };
      } else if (type === 'pageLikes') {
        name = 'Page Likes';
        summary = 'Connect with all the people who matter to your business.';
        designDetails = {
          imageSize: '1200x444 pixels',
          imageRatio: '2.7:1',
          text: '90 Characters',
          headline: '25 Characters'
        };
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.name
      }, name), /*#__PURE__*/React.createElement("h3", {
        className: styles.summary
      }, summary)), /*#__PURE__*/React.createElement("div", {
        className: styles.designDetails
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.designDetailsTitle
      }, "Design Recommendations"), /*#__PURE__*/React.createElement("ul", {
        className: styles.list
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Image Size:"), designDetails.imageSize), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Image Ratio:"), designDetails.imageRatio), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Text:"), designDetails.text), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Headline:"), designDetails.headline), designDetails.linkDescription && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Link Description:"), " ", designDetails.linkDescription), designDetails.newsFeedDescription && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "News Feed Description"), " ", designDetails.newsFeedDescription), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Image Text:"), "Your image should contain mimimal text."))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPreview", function (adDetails, type) {
      var adType = _this.state.selectedPreviewTab.key;

      var sa = _this.props.organization.SocialAccounts.filter(function (acct) {
        return acct.platform === 'Facebook page';
      })[0];

      if (adType === 'fbDesktop') {
        return /*#__PURE__*/React.createElement(FBDesktopPreview, {
          formatType: "image",
          adType: type,
          fbAcct: sa,
          adDetails: adDetails
        });
      } else if (adType === 'fbRight') {
        return /*#__PURE__*/React.createElement(FBRightPreview, {
          formatType: "image",
          adDetails: adDetails,
          fbAcct: sa,
          adType: type
        });
      } else if (adType === 'fbMobile') {
        return /*#__PURE__*/React.createElement(FBMobilePreview, {
          formatType: "image",
          adType: type,
          fbAcct: sa,
          adDetails: adDetails
        });
      } else if (adType === 'instagram') {
        return /*#__PURE__*/React.createElement(FBDesktopPreview, {
          formatType: "image",
          adType: type,
          fbAcct: sa,
          adDetails: adDetails
        });
      }
    });

    _this.state = {
      adPreviewTabs: [{
        title: 'Desktop',
        key: 'fbDesktop',
        icon: 'fa-facebook',
        selected: true
      }, {
        title: 'Mobile',
        key: 'fbMobile',
        icon: 'fa-facebook'
      }, {
        title: 'Right Hand',
        key: 'fbRight',
        icon: 'fa-facebook'
      }],
      selectedPreviewTab: {
        key: 'fbDesktop'
      }
    };
    return _this;
  }

  _createClass(AdTypePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adDetails = _this$props.adDetails,
          type = _this$props.type;
      return /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, type && /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 col-md-4 col-lg-6"
      }, this.renderTypeDetails(type)), /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 col-md-8 col-lg-6"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MiniTabBar, {
        items: this.state.adPreviewTabs,
        onTabClick: this.handlePreviewTabChange,
        borderColor: this.props.theme.colors.gray2,
        style: {
          width: 500
        }
      })), type && adDetails && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, this.renderPreview(adDetails, type)))));
    }
  }]);

  return AdTypePicker;
}(Component), _defineProperty(_class2, "propTypes", _defineProperty({
  type: PropTypes.string.isRequired,
  adDetails: PropTypes.object
}, "type", PropTypes.string)), _defineProperty(_class2, "defaultProps", {
  adDetails: {
    headline: 'Social Media Automated!',
    description: 'Ready to build your Facebook ad? Start by selecting an ad type.',
    img: 'https://s3.amazonaws.com/likeabucket/user_upload/22/SkfpFgfaX.jpeg',
    pageName: 'Likeable Local'
  },
  type: 'pageLikes'
}), _temp)) || _class);
export default AdTypePicker;